import React, {Component} from 'react';
import {Helmet} from 'react-helmet';
import {Link} from 'components/ReactRouterDomLocalized';

import {t, dt} from 'l10n';

import 'sass/headers/header.scss';
import paths from 'paths';

class HeaderFaq extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <header className="faq">
                <Helmet>
                    <title>{dt('meta', 'Frequently Asked Questions (FAQ)')}</title>
                    <meta name="description" content={dt('meta', 'Help page to connect to BobTV Webcam Chat. Visio Chat of exhibitions and meetings between adults.')}/>
                </Helmet>
                <div className="content">
                    <h1 id="faq_header">Vous avez des questions?</h1>
                    <div className="text-subtitle">
                        <p>Les réponses aux questions les plus courantes sont détaillées dans cette rubrique.</p>
                        
                        <p>Pour commencer:</p>
                        <ul>
                            <li>Les salles de tchat fonctionnent sous <strong>Windows (Vista, 7, 8, 10)</strong>, <strong>Mac OS X</strong>, <strong>Android </strong>
                                (version 4.4 et supérieures sur smartphones et tablettes), <strong>iOS 12.2 et supérieures</strong> (sur iPhone ou iPad).
                                Il est impératif d'utiliser les navigateurs <strong>Google Chrome</strong>, <strong>Safari</strong>, <strong>Mozilla Firefox</strong> ou <strong>Opéra</strong> dans
                                leur version la plus récente ou Microsoft Edge à partir de la version 79. <strong>Seul Safari</strong> est pour le moment compatible avec les <strong>iPhone</strong> et
                                les <strong>iPad</strong> en version iOS 12.2 et supérieures.
                            </li>
                            <li>Un accès Internet haut débit de 10 Mo/s minimum est recommandé.</li>
                            <li>Vous devez vous enregistrer et créer un compte gratuit lors de votre première visite.</li>
                        </ul>
                        
                        <p>Si la réponse à votre question ne se trouve pas sur cette page, je vous invite à me la poser sur la page <Link to={paths.contact.path}>contact</Link> du site.</p>
                    </div>
                </div>
            </header>
        )
    }
}

export default HeaderFaq;























// WEBPACK FOOTER //
// ./src/components/faq/HeaderFaq.js